import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaSearch, FaClock, FaRocket } from 'react-icons/fa';

const SearchResultsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="flex-grow max-w-4xl mx-auto px-4 py-12">
        <div className="text-center">
          {/* Coming Soon Icon */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-blue-100 rounded-full mb-6">
              <FaSearch className="text-4xl text-blue-600" />
            </div>
          </div>
          
          {/* Main Content */}
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Search Results
            </h1>
            
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-8">
              <div className="flex items-center justify-center mb-4">
                <FaClock className="text-2xl text-blue-600 mr-3" />
                <span className="text-2xl font-semibold text-blue-800">Coming Soon!</span>
              </div>
              <p className="text-blue-700 text-lg leading-relaxed">
                We're working hard to bring you an amazing search results experience. 
                Soon you'll be able to view and analyze all your previous investment predictions 
                and results in one convenient place.
              </p>
            </div>
            
            {/* Features Preview */}
            <div className="text-left max-w-2xl mx-auto">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
                What's Coming
              </h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FaRocket className="text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Advanced Filtering</h3>
                    <p className="text-gray-600">Filter results by date, model type, performance, and more.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <FaSearch className="text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Smart Search</h3>
                    <p className="text-gray-600">Search through your results with intelligent keywords and tags.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                    <FaClock className="text-purple-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Performance Tracking</h3>
                    <p className="text-gray-600">Track the accuracy and performance of your past predictions over time.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Call to Action */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-gray-600 mb-4">
                In the meantime, you can continue using our investment models:
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a 
                  href="/long-term-model" 
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Long-term Model
                </a>
                <a 
                  href="/short-term-model" 
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Short-term Model
                </a>
                <a 
                  href="/swing-model" 
                  className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Swing Model
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SearchResultsPage;
